import { Container } from "./styles";

interface PropTabs {
    selected?: any,
    setSelected?: any,
    todos?: any,
    ativos?: any,
    pendentes?: any,
}

export default function ApplicantsTab({ selected, setSelected, todos, ativos, pendentes }: PropTabs) {
    return (
        <Container>
            <div
                onClick={(value) => setSelected(value.currentTarget.id)}
                className={selected === 'todos' ? 'selected tab' : 'tab'}
                id='todos'
            >
                Todos 
                <div 
                    className={selected === 'todos' ? 'selected notification' : 'notification'}
                >
                    {todos}
                </div>
            </div>
            <div
                onClick={(value) => setSelected(value.currentTarget.id)}
                className={selected === 'ativos' ? 'selected tab' : 'tab'}
                id='ativos'
            >
                Ativos
                <div
                    className={selected === 'ativos' ? 'selected notification' : 'notification'}
                >
                    {ativos}
                </div>
            </div>
            <div
                onClick={(value) => setSelected(value.currentTarget.id)}
                className={selected === 'pendentes' ? 'selected tab' : 'tab'}
                id='pendentes'
            >
                Pendentes
                <div
                    className={selected === 'pendentes' ? 'selected notification' : 'notification'}
                >
                    {pendentes}
                </div>
            </div>            
        </Container>
    )
}

